// extracted by css-extract-rspack-plugin
export default {"container":"_7a38b8f3","staticImage":"_a290ce8b"};